<ion-content #content>
  <ion-card *ngIf="barcode" style="--background: white;">
    <ion-card-header>
      <ion-card-title>{{ titel }}</ion-card-title>
    </ion-card-header>

    <ion-card-content>
      <app-barcode [barcode]="barcode"></app-barcode>      
      <div>
        <ion-button expand="full" color="primary" appClick (clicked)="onClose()">Schließen</ion-button>
      </div>
    </ion-card-content>
  </ion-card>
</ion-content>